import { useMemo, useState } from "react";
import { useFavourite } from "../context/FavouriteContext";
import News from "./News";
import SkeletonCard from "../SkeletonCard";
import "./FilterNews.css"
export const FilterNews = () => {
  const { favourites, loadingNews, error, clearError } = useFavourite();
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    return favourites.filter((fav) =>
      fav.title?.toLowerCase().includes(query.toLowerCase())
    );
  }, [favourites, query]);

  return (
    <>
      {/* Local search input */}
      <div className="fav_search">
        <input
          type="text"
          placeholder="Search favorites..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>

      {loadingNews && (
        <div className="main_container">
          {Array.from({ length: 8 }).map((_, i) => (
            <SkeletonCard key={i} />
          ))}
        </div>
      )}

      {!loadingNews && !error && <News news={filtered} />}

      {error && (
        <div style={{ color: "red", textAlign: "center" }}>
          <p>Failed to fetch favorites.</p>
          <button onClick={clearError}>Try Again</button>
        </div>
      )}
    </>
  );
};